export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/clips-icon.svg?1f1e6d491e2a92306193b5208a73a8f5";